<template>
  <v-row id="login-content">
    <v-col md="6" sm="12" id="login-banner" :class="{ 'services': showServiceCard }">
      <v-row align="center">
        <v-col cols="12" align-self="center">
          <h1 class="text-h2 lb-title col-md-8 col-sm-10">{{ $t('presentation_p1') }}
            <span>{{ $t('presentation_p2') }}</span></h1>
        </v-col>
      </v-row>
    </v-col>

    <div id="language-selector">
      <language-selector class="float-end mb-5"/>
    </div>
    <v-col md="6" sm="12" id="login-form">


      <v-row align="center">
        <v-col lg="5" md="8" sm="10">
          <v-col cols="12" class="mb-md-16 mb-sm-8 mb-xs-4">
            <img :src="require('@/assets/images/logo/supercloud_normal.png')" class="col-10 center">
          </v-col>
          <h1 class="mb-md-6 mb-sm-3 mb-xs-1 black--text">{{ $t('signup_welcome') }}</h1>
          <login-card @goterror="handleError">
            <template v-slot:bottom>
              <error-card
                v-if="error"
                class="my-2"
                id="login_error_card"
                :email="email"
                :error="error.response.data"
                @close="error = null"
              />
            </template>
          </login-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import errorCard from "@/components/forms/AuthFormErrorCard";
import LoginCard from "./LoginCard";
import Copyrights from "@/components/Copyrights";
import AuthTopBar from "@/components/AppTopBar/AuthTopBar";
import PublicServices from "@/components/PublicServices";
import LanguageSelector from "@/components/LanguageSelector";

export default {
  components: {
    errorCard,
    LoginCard,
    AuthTopBar,
    Copyrights,
    PublicServices,
    LanguageSelector,
  },
  data: () => ({
    error: null,
  }),
  mounted() {
    this.setLanguage();
  },
  computed: {
    email() {
      return this.$store.getters['auth/GET_EMAIL'].email;
    },
    showServiceCard() {
      return this.$store.getters['drawers/isServicesConsole']
    },
  },
  methods: {
    scrollWindow() {
      window.scrollTo(0, 0);
    },
    handleError(error) {
      this.error = error;
    },
    goToSignUp() {
      this.$router.push({name: "join"});
    },
    setLanguage() {
      const setedLocale = localStorage.getItem('locale');
      if (setedLocale) {
        this.$store.commit('ui/SET_LANGUAGE', setedLocale);
      } else {
        this.$store.commit('ui/SET_LANGUAGE');
      }
    },
  }
  ,
  watch: {
    '$vuetify.theme.dark':
      {
        handler: function (val) {
          if (val) {
            // 0 = light
            this.$store.commit("ui/SET_THEME", 0);
          }
        }
        ,
        immediate: true
      }
  }
  ,
}
;
</script>

<style lang="scss">

#language-selector {
  position: absolute;
  right: 1em;
  top: 1em;
}

#login-content {
  min-height: 100vh;
  padding: 0;
  margin: 0;

  .center {
    margin: auto;
    display: flex;
  }

  #login-banner {
    background-color: var(--v-primary-base);

    .row:first-child {
      height: 100%;

      h1 {
        margin: 0 auto;
      }
    }

    .lb-title {
      font-size: 2.625rem;
      color: #FFFFFF;

      span {
        color: var(--v-secondary-base);
        font-weight: 400;
      }
    }

    &.services {
      background-color: var(--v-secondary-base) !important;

      span {
        color: var(--v-primary-base);
      }
    }

  }

  #login-form {

    .row:first-child {
      height: 100%;

      .col {
        margin: 0 auto;
      }

      h1 {
        font-size: 1.5rem !important;
      }
    }
  }
}

@media (max-width: 600px) {
  #login-content {
    min-height: 60vh;

    #login-banner {
      height: fit-content;
      padding-top: 3.5em;

      .lb-title {
        font-size: 1.625rem !important;
        line-height: initial;
      }
    }

    #login-form {

      .row:first-child {
        h1 {
          font-size: 1rem !important;
          margin-bottom: 0.75rem;
        }
      }
    }
  }
}

</style>